module.exports = __webpack_public_path__ + "media/theme/tutorial__dmm--1--create-757f827e.png";